import React from 'react'
import { cnMerge } from '../../utils/twmerge'

interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  className?: string
  label?: string
  indeterminate?: boolean
}

export const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  ({ className, label, indeterminate, ...props }, ref) => {
    // Support for indeterminate state when used as header select-all
    const internalRef = React.useRef<HTMLInputElement>(null)
    React.useEffect(() => {
      if (internalRef.current) {
        internalRef.current.indeterminate = Boolean(indeterminate)
      }
    }, [indeterminate])
    return (
      <div className="flex items-center space-x-2">
        <div className="relative">
          <input
            type="checkbox"
            ref={(node) => {
              internalRef.current = node as HTMLInputElement | null
              if (typeof ref === 'function') ref(node as HTMLInputElement)
              else if (ref) (ref as React.MutableRefObject<HTMLInputElement | null>).current = node as HTMLInputElement | null
            }}
            className={cnMerge(
              'peer h-4 w-4 shrink-0 rounded-sm border border-gray-300 bg-white',
              'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500/20 focus-visible:ring-offset-2',
              'disabled:cursor-not-allowed disabled:opacity-50',
              'checked:bg-blue-600 checked:border-blue-600',
              'transition-colors duration-200',
              className
            )}
            {...props}
          />
          {/* Check Icon */}
        </div>
        {label && (
          <label 
            htmlFor={props.id}
            className="text-sm font-medium text-gray-700 cursor-pointer select-none"
          >
            {label}
          </label>
        )}
      </div>
    )
  }
)

Checkbox.displayName = 'Checkbox'
